import Newsletter from './components/newsletter';
import NewsletterPopup from "modules/wnet_emailsubscription/_dev/src/js/components/newsletterPopup";

$(document).ready(() => {
    let newsletter = new Newsletter();
    let newsletterPopup = new NewsletterPopup();
});
